
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35192',
  depVersions: {
  "documents-public-ui": "static-1.35192",
  "atom": "static-1.5368",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2766",
  "client-types": "static-1.496",
  "cssUtils": "static-1.903",
  "customer-data-filters-ui": "static-1.40867",
  "customer-data-objects": "static-1.7973",
  "customer-data-property-utils": "static-1.8385",
  "documents-lib": "static-1.35197",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.366",
  "FormsCommonComponents": "static-1.86529",
  "FormUrlGenerator": "static-2.5010",
  "foundations-theming-specialty": "static-1.2471",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.109",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5879",
  "hs-test-utils": "static-1.8315",
  "hub-http": "static-1.6496",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12078",
  "HubStyleTokens": "static-2.11771",
  "I18n": "static-7.1669",
  "icons": "static-2.680",
  "jasmine-immutable": "static-1.3304",
  "jasmine-runner": "static-1.6735",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7434",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3177",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5680",
  "quartz": "static-1.7435",
  "react": "static-7.192",
  "react-dlb": "static-1.88",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.17001",
  "react-select-plus": "static-1.110",
  "react-utils": "static-2.5543",
  "react-virtualized": "static-2.105",
  "reference-resolvers": "static-1.8464",
  "reference-resolvers-lite": "static-1.8384",
  "reporting-data": "static-1.68756",
  "reporting-reports": "static-1.68433",
  "reporting-snowflake": "static-1.57373",
  "reporting-testing-lib": "static-1.10689",
  "reporting-visualizations": "static-1.60831",
  "reselect": "static-3.10",
  "sales-content-partitioning": "static-1.9234",
  "sanitize": "static-1.4756",
  "sanitize-text": "static-1.8436",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.2029",
  "signup-constants": "static-1.19596",
  "signup-ui-url-generator": "static-2.8344",
  "StyleGuideUI": "static-3.501",
  "superstore": "static-1.5039",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5041",
  "ui-addon-form-validation": "static-1.11265",
  "ui-asset-management-lib": "static-1.11380",
  "ui-images": "static-2.1243",
  "UIComponents": "static-3.8717",
  "usage-tracker": "static-1.7637",
  "usage-tracker-container": "static-1.7627",
  "usage-tracker-core": "static-1.7487",
  "viral-links-lib": "static-1.7358",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9939",
  "foundations-components": "static-1-ech-accordiontransition-jank.30",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1213",
  "quartz-core": "static-1.6654",
  "quick-fetch": "static-1.4118",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.78",
  "rpc-client-utils": "static-1.4948",
  "ui-addon-i18n": "static-1.11429",
  "ui-addon-upgrades": "static-9.18358",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3607",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3712",
  "quartz-webpack": "static-1.3659",
  "foundations-assets": "static-1.5166",
  "foundations-theming": "static-1.4755",
  "hub-http-janus": "static-1.876",
  "hub-http-shared-msw-handlers": "static-1.10588",
  "hubspotter-http": "static-1.4851",
  "sassPrefix": "static-1.175",
  "conversations-skeleton-state": "static-1.7528",
  "crm-message-bus": "static-1.43725",
  "customer-data-filters-ui-msw-helpers": "static-1.23302",
  "customer-data-objects-ui-components": "static-1.13314",
  "customer-data-reference-ui-components": "static-1.13461",
  "customer-data-ui-utilities": "static-1.10111",
  "events-data-lib": "static-1.526",
  "framework-builder-read-service-client": "static-1.4208",
  "hs-resources": "static-1.475",
  "immer": "static-1.99",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4043",
  "multi-account-reference-resolvers": "static-1.1286",
  "onboarding-scopes": "static-1.6737",
  "onboarding-tours": "static-1.17093",
  "pulse": "static-1.911",
  "reporting-datasets-permissions-lib": "static-1.14433",
  "stylex": "static-1.39",
  "trellis-assets": "static-1.2596",
  "trellis-components": "static-1.2615",
  "trellis-theming": "static-1.1257",
  "ui-addon-teams": "static-1.21889",
  "quartz-auth": "static-1.1110",
  "ui-business-units-lib": "static-1.9370",
  "usage-tracker-session-replay": "static-1.5323",
  "ai-components-ui-library": "static-1.9678",
  "ContentUtils": "static-1.69092",
  "customer-data-properties": "static-1.52533",
  "forms-ai-lib": "static-1.4739",
  "forms-utils-lib": "static-1.13070",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.30",
  "react-dnd-compat": "static-1.4900",
  "react-tinymce": "static-1.55944",
  "tinymce-config": "static-2.55070",
  "ui-gdpr-components": "static-1.10625",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3740",
  "HeadJS": "static-2.794",
  "framer-motion": "static-1.77",
  "hs-test-utils-bend-plugin": "static-1.3426",
  "msw": "static-1.39",
  "testing-library": "static-1.157",
  "hs-locale-management": "static-1.280",
  "ui-fonts": "static-1.1033",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.89",
  "jasmine": "static-4.4596",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1100",
  "web-vitals": "static-1.13",
  "batch-promise": "static-1.1826",
  "external-options-client-types": "static-1.4326",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7175",
  "quartz-i18n": "static-1.1110",
  "frontend-preferences-client": "static-1.8205",
  "graphql": "static-1.87",
  "persist-promise": "static-1.3983",
  "reporting-client-types": "static-1.2674",
  "apollo-stack-hubspot": "static-3.92",
  "growth-payments-core": "static-1.26146",
  "hubspot-apollo-client": "static-1.5161",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.30",
  "quartz-routing": "static-1.865",
  "hs-story-utils": "static-1.9708",
  "react-flip-move": "static-1.76",
  "nested-table": "static-1.517",
  "seat-types-lib": "static-1.685",
  "timezone-utils": "static-2.5528",
  "react-create-root-preference": "static-1.68",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.30",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.71",
  "tanstack-table": "static-1.59",
  "opentelemetry-fe-types": "static-1.52",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.575",
  "module-federation": "static-1.31",
  "opentelemetry-fe": "static-1.427",
  "quartz-test": "static-1.1110",
  "quartz-tracking": "static-1.814",
  "bend-plugin-chirp-manifest": "static-1.358",
  "chirp-fetch": "static-1.2177",
  "merchandise-lib": "static-1.276",
  "purchase-motions-components": "static-1.6340",
  "salesImages": "static-1.546",
  "ts-schema": "static-1.4280",
  "bender-build-tools": "static-1.3431",
  "bend-plugin-foundations-theming": "static-1.3238",
  "restore-request-side-panel-lib": "static-1.1635",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4938",
  "conditional-properties-service-client": "static-1.3999",
  "crm-pipelines-api-client-types": "static-1.4334",
  "event-emitter": "static-1.1235",
  "fdsr-migration-layer": "static-1.294",
  "multi-currency-client-types": "static-1.3895",
  "getting-started-shared-tasks": "static-1.19203",
  "growth-data-modal": "static-1.5869",
  "growth-onboarding-confetti": "static-1.3344",
  "growth-onboarding-next-action-utils": "static-1.2656",
  "navigation-components": "static-1.18796",
  "onboarding-tours-client": "static-1.5308",
  "onboarding-tours-utils": "static-1.1160",
  "ui-shepherd-react": "static-3.10551",
  "ui-shepherd-tracker": "static-1.7932",
  "ui-universal-auth": "static-1.9375",
  "user-context": "static-1.5402",
  "bend-plugin-pulse": "static-1.414",
  "fast-json-patch": "static-1.68",
  "stylex-utils": "static-1.138",
  "base-ui": "static-1.20",
  "react-day-picker": "static-1.8",
  "tanstack-virtual": "static-1.36",
  "hubspotter-http-shared-msw-handlers": "static-1.10586",
  "magpie-lib": "static-1.5741",
  "navigation-messaging": "static-1.8123",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22918",
  "copilot-toolkit": "static-1.11822",
  "cms-field-types": "static-1.5097",
  "content-icons-ui": "static-1.2346",
  "integrations-lib": "static-1.16995",
  "calling-global-api": "static-1.65554",
  "calling-internal-common": "static-1.31600",
  "calling-lifecycle-internal": "static-1.66936",
  "calling-lifecycle-messages": "static-1.59230",
  "commerce-products-lib": "static-1.10496",
  "crm-index-visualization-core": "static-1.4521",
  "crm-links": "static-1.6612",
  "customer-data-properties-shared-msw-handlers": "static-1.9915",
  "file-manager-components": "static-1.24448",
  "formula-editor": "static-1.14731",
  "google-libphonenumber": "static-1.43",
  "inbounddb-objects-service-types": "static-1.4413",
  "meetings-icalendar-utils-lib": "static-1.918",
  "object-builder-ui-client": "static-1.49633",
  "pipeline-validation-client-types": "static-1.4168",
  "property-value-citations": "static-1.3147",
  "smart-data-capture-core": "static-1.108",
  "smart-property-lib": "static-1.8252",
  "tiered-pricing": "static-1.1927",
  "topics-actions-lib": "static-1.447",
  "trial-components-library": "static-1.14081",
  "ui-addon-iframeable": "static-1.9360",
  "zustand": "static-1.83",
  "final-form": "static-1.76",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.76",
  "rich-text-lib": "static-1.20281",
  "tinymce-themes": "static-1.57040",
  "data-token-picker": "static-1.16863",
  "hub-http-contrib": "static-1.3321",
  "interframe": "static-3.5038",
  "tinymce-data": "static-1.41155",
  "tinymce-plugins": "static-1.58184",
  "ui-addon-sales-email": "static-1.5495",
  "framework-data-schema-quick-fetch": "static-1.7080",
  "ui-addon-opt": "static-4.8646",
  "hubspot-apollo-cache": "static-1.620",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.432",
  "opentelemetry-web": "static-1.11",
  "purchase-motions-api": "static-1.6343",
  "onboarding-data-sync-lib": "static-1.2484",
  "growth-onboarding-next-action-components": "static-1.2684",
  "user-context-client": "static-1.4791",
  "idb-keyval": "static-1.49",
  "magpie-types": "static-1.5201",
  "nest": "static-1.518",
  "reactive-lib": "static-1.1002",
  "simple-logging-lib": "static-1.3333",
  "unified-auth-core-lib": "static-1.1171",
  "getting-started-shared-tasks-store": "static-1.18321",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1684",
  "integrations-error-boundary-lib": "static-1.14410",
  "integrations-tracking-lib": "static-1.5891",
  "native-integrations-shared-strings": "static-1.8061",
  "redux-observable": "static-1.73",
  "ReduxMessenger": "static-2.10652",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.889",
  "calling-error-reporting": "static-1.31607",
  "shared-worker-versioning": "static-1.11323",
  "calling-usage-tracker": "static-1.6819",
  "voice-sms-access-library": "static-1.1994",
  "customer-data-tracking": "static-1.7164",
  "commerce-permissions": "static-1.1060",
  "products-iframe-lib": "static-1.8559",
  "products-ui-components-shared-msw-handlers": "static-1.10970",
  "crm-index-associations-lib": "static-1.6725",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10671",
  "sales-views-client-types": "static-1.4539",
  "location-customization-utils-lib": "static-1.10065",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4432",
  "video-components-external": "static-1.12121",
  "video-data-lib": "static-1.35779",
  "bark-lib": "static-1.16795",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.100",
  "crm-properties-common-lib": "static-1.6172",
  "react-codemirror": "static-1.10922",
  "data-agent-kit": "static-1.624",
  "feedback-loader": "static-1.29783",
  "fsm": "static-1.4032",
  "policy-lib": "static-1.7084",
  "react-colorpicker": "static-2.10499",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10734",
  "embedded-academy-lib": "static-1.15475",
  "hubs-service-types": "static-1.1540",
  "FileManagerLib": "static-1.40088",
  "NamespacedHubStyle": "static-2.9250",
  "FileManagerCore": "static-1.39947",
  "content-assistance-lib": "static-1.8176",
  "layout-dnd-components": "static-1.12940",
  "layout-dnd-utils": "static-1.11915",
  "ui-addon-emoji-picker": "static-1.10168",
  "ui-brand-identity-lib": "static-1.16413",
  "InboxConnectUtils": "static-4.15526",
  "meetings-connect-utils-lib": "static-1.7891",
  "breeze-engine-chat-components": "static-1.662",
  "breeze-engine-core": "static-1.962",
  "ably": "static-2.2",
  "highlight.js": "static-1.84",
  "universal-page-editor-lib": "static-1.3290",
  "adobe-sign-auth-lib": "static-1.430",
  "ads-unified-auth-lib": "static-1.1264",
  "generic-oauth-auth-lib": "static-1.17",
  "google-sheets-integration-lib": "static-1.996",
  "microsoft-drive-auth-lib": "static-1.105",
  "surveymonkey-integration-lib": "static-1.443",
  "slack-ui-library": "static-1.10682",
  "calling-orchestration-schema": "static-1.36771",
  "crm-record-cards-service-types": "static-1.3773",
  "content-media-composition-data-lib": "static-1.13203",
  "content-media-compositions": "static-2.17210",
  "media-bridge-lib": "static-1.19382",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16332",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4791",
  "storybook-react": "static-1.38",
  "academy-common-lib": "static-1.14935",
  "audio-components": "static-1.6318",
  "FileManagerImages": "static-1.37599",
  "video-components": "static-1.14123",
  "breeze-artifacts-sdk": "static-1.282",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.59",
  "urlinator": "static-1.4815",
  "video-embed": "static-1.36613",
  "ui-addon-video-player": "static-1.8985",
  "ui-coaching-tips": "static-1.29273",
  "ContentData": "static-1.69167",
  "layout-data-lib": "static-1.10240",
  "academy-service-client": "static-1.3970",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4685",
  "trellis-ecosystem": "static-1.7604",
  "ui-addon-react-router-dom": "static-1.9820",
  "wootric-nps": "static-1.7187",
  "social-insights-client-types": "static-1.22705",
  "outpost": "static-1.4439",
  "growth-onboarding-feedback-components": "static-1.6867",
  "advanced-menus-core": "static-1.15552",
  "advanced-menus-lib": "static-1.12428",
  "ExportDialog": "static-6.10660",
  "ui-memberships-settings-lib": "static-1.34810",
  "marketplace-ui-apps-core": "static-1.19228",
  "marketplace-ui-common": "static-1.20696",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15551",
  "simple-menus-lib": "static-1.17068",
  "developer-experience-shared-components": "static-1.10787",
  "immutable-less": "static-1.4932",
  "marketplace-ui-client-types": "static-1.18103",
  "ui-addon-integrations-directory-panel": "static-2.8308",
  "ui-extensibility-client-types": "static-1.4200",
  "ai-settings-ui-library": "static-1.8305",
  "nav-meta": "static-1.30433",
  "ui-product-approvals-common": "static-1.996",
  "apps-service-types": "static-1.4022",
  "oauth-service-types": "static-1.4520",
  "simple-data-table": "static-1.3502"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35192",
  "atom": "/atom/static-1.5368",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2766",
  "client-types": "/client-types/static-1.496",
  "cssUtils": "/cssUtils/static-1.903",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40867",
  "customer-data-objects": "/customer-data-objects/static-1.7973",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8385",
  "documents-lib": "/documents-lib/static-1.35197",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.366",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86529",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5010",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2471",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.109",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5879",
  "hs-test-utils": "/hs-test-utils/static-1.8315",
  "hub-http": "/hub-http/static-1.6496",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12078",
  "HubStyleTokens": "/HubStyleTokens/static-2.11771",
  "I18n": "/I18n/static-7.1669",
  "icons": "/icons/static-2.680",
  "jasmine-immutable": "/jasmine-immutable/static-1.3304",
  "jasmine-runner": "/jasmine-runner/static-1.6735",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7434",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3177",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5680",
  "quartz": "/quartz/static-1.7435",
  "react": "/react/static-7.192",
  "react-dlb": "/react-dlb/static-1.88",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.17001",
  "react-select-plus": "/react-select-plus/static-1.110",
  "react-utils": "/react-utils/static-2.5543",
  "react-virtualized": "/react-virtualized/static-2.105",
  "reference-resolvers": "/reference-resolvers/static-1.8464",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8384",
  "reporting-data": "/reporting-data/static-1.68756",
  "reporting-reports": "/reporting-reports/static-1.68433",
  "reporting-snowflake": "/reporting-snowflake/static-1.57373",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10689",
  "reporting-visualizations": "/reporting-visualizations/static-1.60831",
  "reselect": "/reselect/static-3.10",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9234",
  "sanitize": "/sanitize/static-1.4756",
  "sanitize-text": "/sanitize-text/static-1.8436",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2029",
  "signup-constants": "/signup-constants/static-1.19596",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8344",
  "StyleGuideUI": "/StyleGuideUI/static-3.501",
  "superstore": "/superstore/static-1.5039",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5041",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11265",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11380",
  "ui-images": "/ui-images/static-2.1243",
  "UIComponents": "/UIComponents/static-3.8717",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "viral-links-lib": "/viral-links-lib/static-1.7358",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9939",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.30",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1213",
  "quartz-core": "/quartz-core/static-1.6654",
  "quick-fetch": "/quick-fetch/static-1.4118",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.78",
  "rpc-client-utils": "/rpc-client-utils/static-1.4948",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11429",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18358",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3607",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3712",
  "quartz-webpack": "/quartz-webpack/static-1.3659",
  "foundations-assets": "/foundations-assets/static-1.5166",
  "foundations-theming": "/foundations-theming/static-1.4755",
  "hub-http-janus": "/hub-http-janus/static-1.876",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10588",
  "hubspotter-http": "/hubspotter-http/static-1.4851",
  "sassPrefix": "/sassPrefix/static-1.175",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7528",
  "crm-message-bus": "/crm-message-bus/static-1.43725",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23302",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13314",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13461",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10111",
  "events-data-lib": "/events-data-lib/static-1.526",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4208",
  "hs-resources": "/hs-resources/static-1.475",
  "immer": "/immer/static-1.99",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4043",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1286",
  "onboarding-scopes": "/onboarding-scopes/static-1.6737",
  "onboarding-tours": "/onboarding-tours/static-1.17093",
  "pulse": "/pulse/static-1.911",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14433",
  "stylex": "/stylex/static-1.39",
  "trellis-assets": "/trellis-assets/static-1.2596",
  "trellis-components": "/trellis-components/static-1.2615",
  "trellis-theming": "/trellis-theming/static-1.1257",
  "ui-addon-teams": "/ui-addon-teams/static-1.21889",
  "quartz-auth": "/quartz-auth/static-1.1110",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9370",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9678",
  "ContentUtils": "/ContentUtils/static-1.69092",
  "customer-data-properties": "/customer-data-properties/static-1.52533",
  "forms-ai-lib": "/forms-ai-lib/static-1.4739",
  "forms-utils-lib": "/forms-utils-lib/static-1.13070",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.30",
  "react-dnd-compat": "/react-dnd-compat/static-1.4900",
  "react-tinymce": "/react-tinymce/static-1.55944",
  "tinymce-config": "/tinymce-config/static-2.55070",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3740",
  "HeadJS": "/HeadJS/static-2.794",
  "framer-motion": "/framer-motion/static-1.77",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3426",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.157",
  "hs-locale-management": "/hs-locale-management/static-1.280",
  "ui-fonts": "/ui-fonts/static-1.1033",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.89",
  "jasmine": "/jasmine/static-4.4596",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1100",
  "web-vitals": "/web-vitals/static-1.13",
  "batch-promise": "/batch-promise/static-1.1826",
  "external-options-client-types": "/external-options-client-types/static-1.4326",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7175",
  "quartz-i18n": "/quartz-i18n/static-1.1110",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8205",
  "graphql": "/graphql/static-1.87",
  "persist-promise": "/persist-promise/static-1.3983",
  "reporting-client-types": "/reporting-client-types/static-1.2674",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.92",
  "growth-payments-core": "/growth-payments-core/static-1.26146",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5161",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.30",
  "quartz-routing": "/quartz-routing/static-1.865",
  "hs-story-utils": "/hs-story-utils/static-1.9708",
  "react-flip-move": "/react-flip-move/static-1.76",
  "nested-table": "/nested-table/static-1.517",
  "seat-types-lib": "/seat-types-lib/static-1.685",
  "timezone-utils": "/timezone-utils/static-2.5528",
  "react-create-root-preference": "/react-create-root-preference/static-1.68",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.30",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.71",
  "tanstack-table": "/tanstack-table/static-1.59",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.52",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.575",
  "module-federation": "/module-federation/static-1.31",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.427",
  "quartz-test": "/quartz-test/static-1.1110",
  "quartz-tracking": "/quartz-tracking/static-1.814",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.358",
  "chirp-fetch": "/chirp-fetch/static-1.2177",
  "merchandise-lib": "/merchandise-lib/static-1.276",
  "purchase-motions-components": "/purchase-motions-components/static-1.6340",
  "salesImages": "/salesImages/static-1.546",
  "ts-schema": "/ts-schema/static-1.4280",
  "bender-build-tools": "/bender-build-tools/static-1.3431",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3238",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1635",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4938",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3999",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4334",
  "event-emitter": "/event-emitter/static-1.1235",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.294",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3895",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19203",
  "growth-data-modal": "/growth-data-modal/static-1.5869",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3344",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2656",
  "navigation-components": "/navigation-components/static-1.18796",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5308",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1160",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10551",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7932",
  "ui-universal-auth": "/ui-universal-auth/static-1.9375",
  "user-context": "/user-context/static-1.5402",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.414",
  "fast-json-patch": "/fast-json-patch/static-1.68",
  "stylex-utils": "/stylex-utils/static-1.138",
  "base-ui": "/base-ui/static-1.20",
  "react-day-picker": "/react-day-picker/static-1.8",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10586",
  "magpie-lib": "/magpie-lib/static-1.5741",
  "navigation-messaging": "/navigation-messaging/static-1.8123",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22918",
  "copilot-toolkit": "/copilot-toolkit/static-1.11822",
  "cms-field-types": "/cms-field-types/static-1.5097",
  "content-icons-ui": "/content-icons-ui/static-1.2346",
  "integrations-lib": "/integrations-lib/static-1.16995",
  "calling-global-api": "/calling-global-api/static-1.65554",
  "calling-internal-common": "/calling-internal-common/static-1.31600",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66936",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59230",
  "commerce-products-lib": "/commerce-products-lib/static-1.10496",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4521",
  "crm-links": "/crm-links/static-1.6612",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9915",
  "file-manager-components": "/file-manager-components/static-1.24448",
  "formula-editor": "/formula-editor/static-1.14731",
  "google-libphonenumber": "/google-libphonenumber/static-1.43",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4413",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.918",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49633",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4168",
  "property-value-citations": "/property-value-citations/static-1.3147",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.108",
  "smart-property-lib": "/smart-property-lib/static-1.8252",
  "tiered-pricing": "/tiered-pricing/static-1.1927",
  "topics-actions-lib": "/topics-actions-lib/static-1.447",
  "trial-components-library": "/trial-components-library/static-1.14081",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9360",
  "zustand": "/zustand/static-1.83",
  "final-form": "/final-form/static-1.76",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.76",
  "rich-text-lib": "/rich-text-lib/static-1.20281",
  "tinymce-themes": "/tinymce-themes/static-1.57040",
  "data-token-picker": "/data-token-picker/static-1.16863",
  "hub-http-contrib": "/hub-http-contrib/static-1.3321",
  "interframe": "/interframe/static-3.5038",
  "tinymce-data": "/tinymce-data/static-1.41155",
  "tinymce-plugins": "/tinymce-plugins/static-1.58184",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5495",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7080",
  "ui-addon-opt": "/ui-addon-opt/static-4.8646",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.620",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.432",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "purchase-motions-api": "/purchase-motions-api/static-1.6343",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2484",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2684",
  "user-context-client": "/user-context-client/static-1.4791",
  "idb-keyval": "/idb-keyval/static-1.49",
  "magpie-types": "/magpie-types/static-1.5201",
  "nest": "/nest/static-1.518",
  "reactive-lib": "/reactive-lib/static-1.1002",
  "simple-logging-lib": "/simple-logging-lib/static-1.3333",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1171",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18321",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1684",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14410",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5891",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8061",
  "redux-observable": "/redux-observable/static-1.73",
  "ReduxMessenger": "/ReduxMessenger/static-2.10652",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.889",
  "calling-error-reporting": "/calling-error-reporting/static-1.31607",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11323",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6819",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1994",
  "customer-data-tracking": "/customer-data-tracking/static-1.7164",
  "commerce-permissions": "/commerce-permissions/static-1.1060",
  "products-iframe-lib": "/products-iframe-lib/static-1.8559",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10970",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6725",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10671",
  "sales-views-client-types": "/sales-views-client-types/static-1.4539",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10065",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4432",
  "video-components-external": "/video-components-external/static-1.12121",
  "video-data-lib": "/video-data-lib/static-1.35779",
  "bark-lib": "/bark-lib/static-1.16795",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.100",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6172",
  "react-codemirror": "/react-codemirror/static-1.10922",
  "data-agent-kit": "/data-agent-kit/static-1.624",
  "feedback-loader": "/feedback-loader/static-1.29783",
  "fsm": "/fsm/static-1.4032",
  "policy-lib": "/policy-lib/static-1.7084",
  "react-colorpicker": "/react-colorpicker/static-2.10499",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10734",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15475",
  "hubs-service-types": "/hubs-service-types/static-1.1540",
  "FileManagerLib": "/FileManagerLib/static-1.40088",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9250",
  "FileManagerCore": "/FileManagerCore/static-1.39947",
  "content-assistance-lib": "/content-assistance-lib/static-1.8176",
  "layout-dnd-components": "/layout-dnd-components/static-1.12940",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11915",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10168",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16413",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15526",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7891",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.662",
  "breeze-engine-core": "/breeze-engine-core/static-1.962",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.84",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3290",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.430",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1264",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.996",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.105",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.443",
  "slack-ui-library": "/slack-ui-library/static-1.10682",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36771",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3773",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13203",
  "content-media-compositions": "/content-media-compositions/static-2.17210",
  "media-bridge-lib": "/media-bridge-lib/static-1.19382",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16332",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4791",
  "storybook-react": "/storybook-react/static-1.38",
  "academy-common-lib": "/academy-common-lib/static-1.14935",
  "audio-components": "/audio-components/static-1.6318",
  "FileManagerImages": "/FileManagerImages/static-1.37599",
  "video-components": "/video-components/static-1.14123",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.282",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.59",
  "urlinator": "/urlinator/static-1.4815",
  "video-embed": "/video-embed/static-1.36613",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8985",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29273",
  "ContentData": "/ContentData/static-1.69167",
  "layout-data-lib": "/layout-data-lib/static-1.10240",
  "academy-service-client": "/academy-service-client/static-1.3970",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4685",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7604",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9820",
  "wootric-nps": "/wootric-nps/static-1.7187",
  "social-insights-client-types": "/social-insights-client-types/static-1.22705",
  "outpost": "/outpost/static-1.4439",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6867",
  "advanced-menus-core": "/advanced-menus-core/static-1.15552",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12428",
  "ExportDialog": "/ExportDialog/static-6.10660",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34810",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19228",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20696",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15551",
  "simple-menus-lib": "/simple-menus-lib/static-1.17068",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10787",
  "immutable-less": "/immutable-less/static-1.4932",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18103",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8308",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4200",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8305",
  "nav-meta": "/nav-meta/static-1.30433",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.996",
  "apps-service-types": "/apps-service-types/static-1.4022",
  "oauth-service-types": "/oauth-service-types/static-1.4520",
  "simple-data-table": "/simple-data-table/static-1.3502"
}
};
